<template>
    <p-modal 
            name="InvoiceDetailReportModal"
            label="Invoice Detail Report"
            ref="InvoiceDetailReportModal"
            size="lg"
            @ok.prevent="handleModalOk"
            >
        <template v-slot:default>
            <p-form ref="InvoiceDetailReportForm">
                <div class="container-fluid content-wrapper">
                    <p-modal-date-range :date-range-options="reportParameters" />
                    <b-row cols="1" cols-lg="2">
                        <b-col>
                            <p-select 
                                v-model="reportParameters.status"
                                rules="required"
                                name="Status"
                                label="Status"
                                mode="lazy"
                                :options="status" />
                        </b-col>    
                        <b-col>
                            <p-advanced-select 
                                v-model="reportParameters.supplierId"  
                                add-empty-option  
                                label="Supplier"
                                data-type="suppliers"
                                text-field="text"
                                value-field="value"
                                mode="lazy"
                            />            
                        </b-col>
                    </b-row>
                    <UserReportTemplate 
                        :user-report-template-options="userReportTemplateOptions"
                        v-model:selected-user-report-template-id="selectedUserReportTemplateId"
                        :selected-user-report-template="selectedUserReportTemplate"
                        v-model:template-name="templateName"
                        @selected-object="applyUserReportTemplate($event)" />
                </div>
            </p-form> 
        </template>
        <template v-slot:modal-footer="{ ok }" >
            <b-row>
                <b-col class=" mb-3 text-center">
                        <p-button  :is-busy="isBusy" variant="outline-primary" @click="ok">OK</p-button>
                    </b-col>
            </b-row>
        </template>
    </p-modal>
</template>

<script>

import axios from 'axios';
import { downloadFileToBrowser } from '@/components/Common/BrowserDownload.js';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import ReportTemplates from '@/components/mixins/ReportTemplates.js';
import UserReportTemplate from '@/components/UserReportTemplate.vue';

export default {
    props: {},
    mixins: [ReportTemplates],
    data() {
        return {
            isBusy: false,
            // Identifies which report saved templates belong to; must match the report name in Reports.vue.
            reportName: 'Invoice Detail Report',
            reportParameters: {
                fromDate: null,
                toDate: null,
                status: '',
                supplierId: null
            },
            status: [
                { text: 'All', value: 'All' },
                { text: 'Open', value: 'Open' },
                { text: 'Paid', value: 'Paid' },
            ],
        };
    },
     components: {
        UserReportTemplate
    },
    methods: {
        async show() {
            this.$refs.InvoiceDetailReportModal.show();
            await this.loadUserReportTemplates();
        },
        handleModalOk: async function() {
            if (!(await this.$refs.InvoiceDetailReportForm.validate())) {
                return;
            }
            this.isBusy = true;

            if (!(await this.saveUserReportTemplate())) {
                this.isBusy = false;
                return;
            }

            await axios
                .post(
                    '/Invoices/exportInvoiceDetailCsv',
                    this.reportParameters,
                    {
                        responseType: 'blob'
                    }
                )
                .then(result => {
                    downloadFileToBrowser(
                        result.data,
                        'Export_Invoice_Detail.csv',
                        'application/csv'
                    );
                    this.$appSuccess(
                            `Invoice Detailed report generated successfully.`
                        )
                    this.$refs.InvoiceDetailReportModal.hide();
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        // ReportTemplates hook: return false when anything in the saved template can no longer be
        // selected, and the mixin warns and loads nothing. The status comes from a fixed local
        // list, and a saved supplier can be gone by the time the template is loaded — the dropdown
        // won't always catch that on its own, since p-advanced-select only re-checks its bound
        // value when its option list contains disabled entries. The dates are literal values.
        async validateReportParameters(savedParameters) {
            if (!this.status.some(statusOption => statusOption.value === savedParameters.status)) {
                return false;
            }

            // add-empty-option makes "no supplier" a valid saved state.
            if (savedParameters.supplierId == null) {
                return true;
            }

            const suppliers = await selectListOptionsDataContext.getStoreDropdownData('suppliers');

            return suppliers.some(supplier => supplier.value == savedParameters.supplierId);
        },
    }
};

</script>

<style scoped></style>
